import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class HowToGuide extends ApplicationRecord {
  static jsonapiType = "how_to_guides";

  @Attr() title: string;

  @Attr() content: string;

  @Attr() videoUrl: string;
}

export default HowToGuide;
